var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      staticClass: "mb-0",
      attrs: {
        label: "Shadow Projection",
        "label-for": "projection-edit-toggle",
      },
    },
    [
      _c(
        "div",
        { staticClass: "projection-settings border rounded p-3 bg-light" },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { id: "projection-edit-toggle" },
              on: { input: _vm.onChange },
              model: {
                value: _vm.edit,
                callback: function ($$v) {
                  _vm.edit = $$v
                },
                expression: "edit",
              },
            },
            [_vm._v("\n      Edit Mode\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-wrap text-center justify-content-between",
              },
              [
                _c(
                  "div",
                  { staticClass: "w-50 p-1" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass:
                          "w-100 d-flex align-items-center justify-content-center",
                        staticStyle: { gap: "4px" },
                        attrs: { variant: "outline-primary", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.applyProjectionPattern(
                              _vm.PRESETS.LEFT_BACK
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "bi bi-arrow-up-left-square-fill me-2 mt-0",
                          staticStyle: { "margin-top": "-2px!important" },
                        }),
                        _vm._v("\n            Left Back\n          "),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-50 p-1" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass:
                          "w-100 d-flex align-items-center justify-content-center",
                        staticStyle: { gap: "4px" },
                        attrs: { variant: "outline-primary", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.applyProjectionPattern(
                              _vm.PRESETS.RIGHT_BACK
                            )
                          },
                        },
                      },
                      [
                        _vm._v("\n            Right Back\n            "),
                        _c("i", {
                          staticClass: "bi bi-arrow-up-right-square-fill",
                          staticStyle: { "margin-top": "-2px!important" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-50 p-1" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass:
                          "w-100 d-flex align-items-center justify-content-center",
                        staticStyle: { gap: "4px" },
                        attrs: { variant: "outline-primary", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.applyProjectionPattern(
                              _vm.PRESETS.LEFT_FRONT
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "bi bi-arrow-down-left-square-fill",
                          staticStyle: { "margin-top": "-2px!important" },
                        }),
                        _vm._v("\n            Left Front\n          "),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-50 p-1" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass:
                          "w-100 d-flex align-items-center justify-content-center",
                        staticStyle: { gap: "4px" },
                        attrs: { variant: "outline-primary", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.applyProjectionPattern(
                              _vm.PRESETS.RIGHT_FRONT
                            )
                          },
                        },
                      },
                      [
                        _vm._v("\n            Right Front\n            "),
                        _c("i", {
                          staticClass: "bi bi-arrow-down-right-square-fill",
                          staticStyle: { "margin-top": "-2px!important" },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { staticClass: "mt-3 mb-0", attrs: { label: "Fade" } },
            [
              _c(
                "b-input-group",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c("b-input", {
                            attrs: { max: 100, min: 0, type: "number" },
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.fade,
                              callback: function ($$v) {
                                _vm.fade = _vm._n($$v)
                              },
                              expression: "fade",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-input", {
                    attrs: { max: 100, min: 0, type: "range" },
                    on: { input: _vm.onChange },
                    model: {
                      value: _vm.fade,
                      callback: function ($$v) {
                        _vm.fade = _vm._n($$v)
                      },
                      expression: "fade",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }